import React, { Suspense, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ModuleLoaderLazy from './redux/ModuleLoaderLazy';
import GroupGallectionPopover from './GroupGallectionPopover';
import s from './GroupGallectionSelector.scss';
const GroupGallectionSelector = ({ className, gallectionType, group, selected, onSelect })=>{
    const { t } = useTranslation();
    const [showPopover, setShowPopover] = useState(false);
    const hidePopover = useCallback(()=>setShowPopover(false), []);
    const togglePopover = useCallback(()=>setShowPopover(!showPopover), [
        showPopover
    ]);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "ModalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, null)
    }, /*#__PURE__*/ React.createElement(ModuleLoaderLazy, null), /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['toggle']
    }, t('groupGallectionSelector.popover.toggle.addToGroup')), /*#__PURE__*/ React.createElement(TextButton, {
        onClick: togglePopover,
        size: "small",
        variant: "main",
        className: s['btn-toggle'],
        postfix: showPopover ? ArrowUp : ArrowDown
    }, (selected === null || selected === void 0 ? void 0 : selected.name) || 'Featured'), /*#__PURE__*/ React.createElement(GroupGallectionPopover, {
        group: group,
        isVisible: showPopover,
        gallectionType: gallectionType,
        requestClose: hidePopover,
        selected: selected,
        onSelect: onSelect
    }))));
};
GroupGallectionSelector.displayName = 'GroupGallectionSelector';
export default GroupGallectionSelector;
